import axios from 'axios';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { CommonState, error, isFetching } from '@pec/aion-ui-core/slices/common';
import { enqueueRequestErrorSnackbar } from '@pec/aion-ui-core/actions/enqueueSnackbar';

const name = 'businessShieldCredits';

export const fetchBusinessShieldCredits = createAsyncThunk(
  `${name}/fetch`,
  async ({ userId, organizationId }: { userId: string; organizationId: string }, { dispatch }) => {
    try {
      const { data } = await axios.get<number>(
        `/api/v1/products/addons/businessshield/organizations/${organizationId}/users/${userId}/credits`
      );
      return data;
    } catch (error) {
      dispatch(enqueueRequestErrorSnackbar());
      throw error;
    }
  }
);

export type State = CommonState & {
  credits: number;
};

const initialState: State = {
  credits: 0,
  isFetching: false,
  error: null
};

const businessShieldCredits = createSlice({
  name,
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(fetchBusinessShieldCredits.pending, isFetching)
      .addCase(fetchBusinessShieldCredits.fulfilled, (state, action) => {
        state.credits = action.payload;
        state.isFetching = false;
      })
      .addCase(fetchBusinessShieldCredits.rejected, error);
  }
});

export const { reducer: businessShieldCreditsReducer } = businessShieldCredits;
